import { api } from './api';

const transactionService = {
  // Criar transação
  create: async (data) => {
    const response = await api.post('/transactions', data);
    return response.data;
  },

  // Buscar transações com filtros
  getAll: async (params = {}) => {
    const response = await api.get('/transactions', { params });
    return response.data;
  },

  // Buscar transação por ID
  getById: async (id) => {
    const response = await api.get(`/transactions/${id}`);
    return response.data;
  },

  // Atualizar transação
  update: async (id, data) => {
    const response = await api.put(`/transactions/${id}`, data);
    return response.data;
  },

  // Deletar transação
  delete: async (id) => {
    const response = await api.delete(`/transactions/${id}`);
    return response.data;
  },

  // Buscar resumo financeiro
  getSummary: async (params = {}) => {
    const response = await api.get('/transactions/summary', { params });
    return response.data;
  },

  // Buscar dados dos gráficos
  getCharts: async (params = {}) => {
    const response = await api.get('/transactions/charts', { params });
    return response.data;
  },

  // Buscar categorias de despesas
  getExpenseCategories: async (params = {}) => {
    const response = await api.get('/transactions/expense-categories', { params });
    return response.data;
  },
};

export default transactionService;

